import script from "./ViewDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDetails.vue?vue&type=script&setup=true&lang=js"

import "./ViewDetails.vue?vue&type=style&index=0&id=b9999b30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9999b30"]])

export default __exports__